export default __webpack_public_path__ + "static/media/FileIcon.62f3763c.svg";